import { Mail, Loader2, Edit } from "lucide-react";
import { Button } from "@/components/ui/button";
import { onboardingCopy } from "@/lib/onboarding-copy";

interface Step2EmailValidationProps {
  email: string;
  onResendEmail: () => Promise<void>;
  onAlreadyConfirmed: () => void;
  onChangeEmail: () => void;
  isResending: boolean;
  isChangingEmail?: boolean;
}

export function Step2EmailValidation({
  email,
  onResendEmail,
  onAlreadyConfirmed,
  onChangeEmail,
  isResending,
  isChangingEmail = false,
}: Step2EmailValidationProps) {
  return (
    <section className="bg-white border-2 rounded-2xl p-8 shadow-2xl space-y-6 animate-fade-in max-w-2xl mx-auto">
      <div className="text-center mb-6">
        <div className="flex justify-center mb-4">
          <Mail className="h-12 w-12 text-primary" />
        </div>
        <h2 className="text-2xl font-bold text-primary mb-2">
          {onboardingCopy.confirm.title}
        </h2>
        <p className="text-muted-foreground">
          {onboardingCopy.confirm.description.replace(
            "{{email}}",
            email || "seu e-mail"
          )}
        </p>
      </div>

      <div className="space-y-4">
        <Button
          onClick={() => onResendEmail()}
          className="w-full"
          size="lg"
          variant="outline"
          disabled={isResending}
        >
          {isResending ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Enviando...
            </>
          ) : (
            <>
              <Mail className="mr-2 h-4 w-4" />
              {onboardingCopy.confirm.resendButton}
            </>
          )}
        </Button>

        <p className="text-xs text-center text-muted-foreground">
          {onboardingCopy.confirm.spamNote}
        </p>

        <div className="pt-4 border-t space-y-3">
          <Button
            onClick={onAlreadyConfirmed}
            variant="ghost"
            className="w-full"
          >
            Já confirmei meu e-mail → Continuar
          </Button>
          
          <Button
            onClick={onChangeEmail}
            variant="outline"
            className="w-full"
            size="sm"
            disabled={isChangingEmail}
          >
            {isChangingEmail ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Redirecionando...
              </>
            ) : (
              <>
                <Edit className="mr-2 h-4 w-4" />
                Coloquei o e-mail errado? Mudar e-mail
              </>
            )}
          </Button>
        </div>
      </div>
    </section>
  );
}

